
export const products = {
  'product.categories': 'Produktkategorien',
  'explore.solutions': 'Entdecken Sie unser umfassendes Angebot an professionellen AV-Lösungen',
  'view.video': 'Produktübersichtsvideo ansehen',
  'AV Over IP': 'AV Über IP',
  'ReAX Control': 'ReAX Steuerung',
  'Meeting Room Solutions': 'Meetingraum-Lösungen',
  'Converters/Scalers': 'Konverter/Skalierer',
  'Audio Products': 'Audioprodukte',
  'HDMI Switchers': 'HDMI-Umschalter',
  'IPBaseT': 'IPBaseT',
  'HDBaseT Products': 'HDBaseT-Produkte',
  'Complete AV distribution solution with ultra-low latency': 'Komplette AV-Verteilungslösung mit ultraniedriger Latenz',
  'Professional control system solutions': 'Professionelle Steuerungssystemlösungen',
  'Complete solutions for modern meeting spaces': 'Komplettlösungen für moderne Besprechungsräume',
  'Professional format conversion and scaling solutions': 'Professionelle Formatumwandlungs- und Skalierungslösungen',
  'Professional audio processing and playback solutions': 'Professionelle Audioverarbeitungs- und Wiedergabelösungen',
  'Professional HDMI switching and distribution solutions': 'Professionelle HDMI-Umschalt- und Verteilungslösungen',
  'Advanced IP-based AV distribution platform': 'Fortschrittliche IP-basierte AV-Verteilungsplattform',
  'Professional HDBaseT distribution solutions': 'Professionelle HDBaseT-Verteilungslösungen',
  'group.not.found': 'Gruppe nicht gefunden',
  'product.not.found': 'Produkt nicht gefunden',
  'return.to.home': 'Zurück zur Startseite',
  'back.to.product.group': 'Zurück zur Produktgruppe',
  'overview': 'Übersicht',
  'full.description': 'Vollständige Beschreibung',
  'features': 'Funktionen',
  'specifications': 'Spezifikationen',
};
